import { useMsal } from "@azure/msal-react";
import { alert } from "contexts";
import useDidMount from "hooks/useDidMount";
import { useMutation } from "react-query";
import { authLoginService } from "services";
import { useAppDispatch } from "stores";
import { initUserSessionAction } from "stores/Auth";
import { saveAccessToken, saveRefreshToken } from "utils";

export const AzureInitializer = () => {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();

  const signInMutation = useMutation(authLoginService, {
    onSuccess: (res) => {
      const { accessToken, refreshToken } = res?.data ?? {};
      if (!accessToken || !refreshToken) return;
      saveAccessToken(accessToken);
      saveRefreshToken(refreshToken);
      dispatch(initUserSessionAction());
    },
  });

  useDidMount(() => {
    instance
      .handleRedirectPromise()
      .then((azureRes) => {
        if (!azureRes) return;
        signInMutation.mutate({
          provider: "azure",
          authData: {
            accessToken: azureRes?.accessToken,
            idToken: azureRes?.idToken,
            oid: (azureRes?.idTokenClaims as { oid: string })?.oid,
          },
        });
      })
      .catch(() => {
        alert({
          title: "Login Failed",
          content: "Please ensure your credentials are valid and try again!",
        });
      });
  });

  return null;
};
